<template>
  <div
    class="name-container text-left"
    :class="{ 'bg-off-white': darkBg }"
  >
    <div
      class="flex items-center justify-between"
      @click="toggleDetails"
    >
      <div class="flex w-10/12 items-center justify-between text-ellipsis">
        <p class="w-8/12 truncate text-xxs text-dark-gray">
          {{ email }}
        </p>
        <p
          v-if="status === 'claimed'"
          class="accepted-status"
        >
          Accepted
        </p>
        <p
          v-else
          class="pending-status"
        >
          Pending
        </p>
      </div>
      <img
        class="h-8 w-8"
        :class="{ '-rotate-180 transform': details }"
        src="@/assets/arrow-down-black.svg"
        alt="arrow icon"
      />
    </div>
    <div
      v-if="details"
      class="mt-5"
    >
      <div class="flex">
        <p class="mb-4 w-1/4 text-2xs font-bold uppercase text-dark-blue">
          Sent By
        </p>
        <p class="text-xxs text-body-color">
          {{ senderName }}
        </p>
      </div>
      <div class="flex">
        <p class="mb-4 w-1/4 text-2xs font-bold uppercase text-dark-blue">
          Sent Date
        </p>
        <p class="text-xxs text-body-color">
          {{ sentDate }}
        </p>
      </div>
      <div class="flex">
        <p class="w-1/4 text-2xs font-bold uppercase text-dark-blue">
          User Role
        </p>
        <p class="text-xxs capitalize text-body-color">
          {{ role }}
        </p>
      </div>
      <div class="flex gap-2">
        <button
          :disabled="invitation.status === 'claimed'"
          :class="
            invitation.status === 'claimed'
              ? 'btn-disabled cursor-default opacity-50'
              : ''
          "
          class="delete-button w-1/2 items-center"
          @click="resendInvitation(invitation.id)"
        >
          Resend
          <img
            src="@/assets/resend.svg"
            class="icon ml-2 inline h-4"
            alt="trash icon"
            @click="toggleDetails"
          />
        </button>
        <button
          :disabled="invitation.status === 'claimed'"
          :class="
            invitation.status === 'claimed'
              ? 'btn-disabled cursor-default opacity-50'
              : ''
          "
          class="delete-button w-1/2 items-center"
          @click="toggleDeleteModalOn(invitation.id)"
        >
          Delete
          <img
            src="@/assets/trash-icon.svg"
            class="icon ml-2 inline h-4"
            alt="trash icon"
          />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'Company User Card',
  props: {
    invitation: Object,
    darkBg: {
      default: false,
    },
    toggleDeleteModalOn: Function,
  },
  data() {
    return {
      details: false,
    };
  },
  computed: {
    email() {
      return this.invitation.email;
    },
    sentDate() {
      return moment(this.invitation.created_at).format('h:mm A  M/D/YY');
    },
    role() {
      return this.invitation.scopes[0];
    },
    status() {
      return this.invitation.status;
    },
    senderName() {
      return this.invitation.creator.name;
    },
  },
  methods: {
    toggleDetails() {
      this.details = !this.details;
    },
    async resendInvitation(id) {
      await this.$store.dispatch('userInvitations/resendUserInvitation', id);
      this.$toast.open({
        message: 'Invitation resent',
        type: 'success',
        duration: 5000,
        dismissible: true,
        position: 'top-right',
      });
    },
  },
};
</script>

<style>
.name-container {
  padding: 12px 14px;
}

.button {
  @apply mt-4 w-full cursor-pointer rounded-md border border-gray-over-dark bg-white text-1md text-gray-over-dark;
  padding: 8.5px 0px !important;
}

.accepted-status {
  padding: 4px 8px;
  background: #ddf4e3;
  border-radius: 30px;
  font-size: 10px;
  width: 65px;
  height: 24px;
  @apply text-green-500;
}

.icon {
  margin-bottom: 2px;
}

.pending-status {
  padding: 4px 8px;
  background: #d6d7da;
  border-radius: 30px;
  font-size: 10px;
  width: 58px;
  height: 24px;
  @apply text-dark-gray;
}
</style>
